import Cards from './CardsClass.js';
export default new Cards('Open');
